package org.catharsis.spendtel.feature.data

import kotlin.time.Clock
import kotlin.time.ExperimentalTime

@OptIn(ExperimentalTime::class)
fun authUserToSpendtelUser(
    uid: String,
    email: String?,
    photoUrl: String? = null,
): SpendtelUser {
    return SpendtelUser(
        uid = uid,
        emailAddress = email.orEmpty(),
        joined = Clock.System.now().toEpochMilliseconds(),
        username = email?.substringBefore("@").orEmpty().ifBlank { "anonymous" },
        profileImage = photoUrl.orEmpty(),
    )
}
